import { css } from '@emotion/react';
import { Button, Typography } from '@mui/material';
import { ReactNode } from 'react';

const placeholderCss = css`
  border: 1px dashed var(--mui-palette-divider);
  border-radius: 0.5rem;
  padding: 1rem;
`;

interface ISectionPlaceholderProps {
  label: string;
  /** Renders a Retry button under the label, for a failed fetch. */
  onRetry?: () => void;
  /** Any other control under the label. */
  children?: ReactNode;
  /** Where a caller's `css` prop lands, for its own margins. */
  className?: string;
}

/** A section body's stand-in while it loads or after it fails: a dashed box with a caption. */
export function SectionPlaceholder({ label, onRetry, children, className }: ISectionPlaceholderProps) {
  return (
    <div css={placeholderCss} className={className}>
      <Typography variant='body2' color='text.secondary'>
        {label}
      </Typography>
      {onRetry && (
        <Button size='small' onClick={onRetry}>
          Retry
        </Button>
      )}
      {children}
    </div>
  );
}
